module.exports = "/_next/static/resources/photo-1-c9d9cdd94b6cf1431c7e9f35426b0701.webp";